import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { RiArrowLeftSLine } from "react-icons/ri";
import Rating from "@mui/material/Rating";
import toast from "react-hot-toast";
//import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { BiLogoEtsy, BiPencil } from "react-icons/bi";
import { isMobile } from "react-device-detect";
import OTPInput from "react-otp-input";
import {
  Dialog,
  Box,
  Typography,
  IconButton,
  Paper,
  Radio,
  Chip,
  Button,
  TextField,
  Grid,
  InputAdornment,
} from "@mui/material";
//import CloseIcon from '@mui/icons-material/Close';
//import CreditCardIcon from '@mui/icons-material/CreditCard';

// Components
import LoggedNav from "../components/LoggedNav";
import Footer from "../components/Footer";
import Spinner from "../element/BePatient";
import CardFieldsModal from "./CardFieldsModal";
import PaypalVaultSection from "./PaypalVaultSection";
import { callErrorApi } from "../errorHandle/callErrorApi";
import $ from "jquery";
import ReCAPTCHA from "react-google-recaptcha";


const CARD_TYPES = [
  {
    name: "visa",
    pattern: /^4/,
    icon: "https://cdn.jsdelivr.net/npm/payment-icons@1.1.0/min/flat/visa.svg",
  },
  {
    name: "mastercard",
    pattern: /^(5[1-5]|2[2-7])/,
    icon: "https://cdn.jsdelivr.net/npm/payment-icons@1.1.0/min/flat/mastercard.svg",
  },
  {
    name: "amex",
    pattern: /^3[47]/,
    icon: "https://cdn.jsdelivr.net/npm/payment-icons@1.1.0/min/flat/amex.svg",
  },
  {
    name: "discover",
    pattern: /^6(?:011|5)/,
    icon: "https://cdn.jsdelivr.net/npm/payment-icons@1.1.0/min/flat/discover.svg",
  },
];

/*const initialOptions = {
  "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
  currency: "USD",
  intent: "tokenize", 
  vault: true, 
  commit: false,
  "enable-funding": "paypal, card",
  "disable-funding": "credit",
  components: "buttons"
};
*/

const addCardToVault = async (paymentDetails) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}user/add_card_to_vault`,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(paymentDetails),
      }
    );

    const result = await response.json();
    if (!result.status) {
      throw new Error(result.message || "Failed to save payment method");
    }
    return result;
  } catch (error) {
    console.error("Error saving payment method:", error);
    throw error;
  }
};

const detectCardType = (number) => {
  const cleanNumber = number.replace(/\D/g, "");
  const type = CARD_TYPES.find((t) => t.pattern.test(cleanNumber));
  return type ? type.name : "UNKNOWN";
};

const formatCardNumber = (value) => {
  const cleanValue = value.replace(/\D/g, "");
  const groups = cleanValue.match(/.{1,4}/g) || [];
  return groups.join(" ").substr(0, 19);
};

// Sub-Components
const DemoOTPDialog = ({ open, onClose, onVerify }) => {
  const [otpValues, setOtpValues] = useState(Array(4).fill(""));
  const [enteredOTP, setEnteredOTP] = useState("");
  const [verifyingOTP, setVerifyingOTP] = useState(false);
  const inputRefs = useRef([]);
  const demoOTP = "1234";

  useEffect(() => {
    if (open) {
      setOtpValues(Array(4).fill(""));
      setEnteredOTP("");
      setVerifyingOTP(false);
      inputRefs.current[0]?.focus();
    }
  }, [open]);

  const handleChange = (index, e) => {
    const value = e.target.value;
    if (!/^\d$/.test(value)) return;

    const newOtpValues = [...otpValues];
    newOtpValues[index] = value;
    setOtpValues(newOtpValues);
    setEnteredOTP(newOtpValues.join(""));

    if (index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const newOtpValues = [...otpValues];
      if (otpValues[index] === "" && index > 0) {
        newOtpValues[index - 1] = "";
        setOtpValues(newOtpValues);
        setEnteredOTP(newOtpValues.join(""));
        inputRefs.current[index - 1]?.focus();
      } else {
        newOtpValues[index] = "";
        setOtpValues(newOtpValues);
        setEnteredOTP(newOtpValues.join(""));
      }
    }
  };

  const handleVerify = () => {
    setVerifyingOTP(true);
    setTimeout(() => {
      if (enteredOTP === demoOTP) {
        toast.success("OTP verified successfully!");
        onVerify();
        onClose();
      } else {
        toast.error("Invalid OTP");
      }
      setVerifyingOTP(false);
    }, 1000);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: isMobile ? "90vw" : "390px", borderRadius: "10px" } }}
    >
      <Box sx={{ p: 3 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography variant="h6">Verify OTP</Typography>
          <IconButton onClick={onClose}></IconButton>
        </Box>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Demo OTP: {demoOTP}
        </Typography>
        <Box sx={{ display: "flex", gap: 2, justifyContent: "center", mb: 3 }}>
          {otpValues.map((value, index) => (
            <TextField
              key={index}
              inputRef={(ref) => (inputRefs.current[index] = ref)}
              type="text"
              inputMode="numeric"
              value={value}
              onChange={(e) => handleChange(index, e)}
              onKeyDown={(e) => handleKeyDown(index, e)}
              inputProps={{ maxLength: 1, style: { textAlign: "center" } }}
              sx={{
                width: "44px",
                "& .MuiOutlinedInput-root": {
                  height: "44px",
                  borderRadius: "50%",
                  background: "#f5f5f5",
                  fontSize: "1.3rem",
                  boxShadow: "0 0 0 1.5px #FF5E41 inset",
                  padding: 0,
                  justifyContent: "center",
                  alignItems: "center",
                },
                "& .MuiInputBase-input": {
                  textAlign: "center",
                  padding: 0,
                },
              }}
            />
          ))}
        </Box>
        <Typography variant="body2" sx={{ mb: 2, textAlign: "center" }}>
          Please enter the OTP to verify
        </Typography>
        <Button
          fullWidth
          variant="contained"
          disabled={verifyingOTP || enteredOTP.length !== 4}
          onClick={handleVerify}
          sx={{
            backgroundColor: "#FF5E41",
            borderRadius: "50px",
            "&:hover": {
              backgroundColor: "#fff",
              color: "#FF5E41",
              border: "1px solid #ffb199",
            },
          }}
        >
          {verifyingOTP ? "Verifying..." : "Verify OTP"}
        </Button>
      </Box>
    </Dialog>
  );
};

const PaymentMethodDialog = ({
  open,
  onClose,
  onPaymentMethodSelect,
  address,
  postalCode,
  setShowPaymentDialog,
  bookChef,
}) => {
  const [selectedMethod, setSelectedMethod] = useState("paypal");
  const [cardType,setCardType] = useState(null);
  const [showDemoOTP, setShowDemoOTP] = useState(false);
  const [cardFormData, setCardFormData] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [paypalError, setPaypalError] = useState(null);
  const [recaptchaToken, setRecaptchaToken] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (open) {
      setSelectedMethod("paypal");
      setPaypalError(null);
      setCardType(null);
      setCardFormData(null);
    }
  }, [open]);

  const detectCardType = (number) => {
    const cleanNumber = number.replace(/\D/g, "");
    return CARD_TYPES.find((type) => type.pattern.test(cleanNumber)) || null;
  };

  const formatCardNumber = (value) => {
    const cleanValue = value.replace(/\D/g, "");
    const groups = cleanValue.match(/.{1,4}/g) || [];
    return groups.join(" ").substr(0, 19);
  };

  const handlePayPalSuccess = async (vaultToken) => {
    setPaypalError(null);
    const success = await bookChef(vaultToken);
    setShowPaymentDialog(false);
    if (success) {
      // Set flag to prevent popups on subscription summary page
      localStorage.setItem("booking_completed", "true");
      setTimeout(() => {
        navigate("/subscription-summary");
      }, 5000);
    }
  };

  const handlePayPalError = (error) => {
    console.error("PayPal error in dialog:", error);
    setPaypalError(error.message || "Failed to save PayPal account");
    console.log("Failed to save PayPal account. Please try again.");
  };

  const handleCardSubmit = (e) => {
    e.preventDefault();
    const data = new FormData(e.target);

   const cardDetails = {
  number: data.get("cardNumber").replace(/\s/g, ""), // ✅ card number without spaces
  expire_year: data.get("expYear"), // ✅ backend expects expire_year
  expire_month: data.get("expMonth").padStart(2, "0"), // ✅ backend expects expire_month (always 2 digits)
  cvv2: data.get("cvv"), // ✅ CVV required
  first_name: data.get("firstName"), // ✅ backend expects separate fields
  last_name: data.get("lastName"),
  billing_address: {
    address: data.get("address"), // ✅ correct key (was "address")
    city: data.get("city"), // ✅ city
    state: data.get("state"), // ✅ state
    postal_code: data.get("postalCode"), // ✅ postal code
    country_code: "US", // ✅ country
  },

  type: detectCardType(data.get("cardNumber").replace(/\s/g, ""))?.name || null, // ✅ detect dynamically
};


    setCardFormData({
      ...cardDetails,
      user_id: Number(localStorage.getItem("logged_user_id")),
    });
    setShowDemoOTP(true);
  };

  const handleOTPVerify = async () => {
    if (!cardFormData) return;
    try {
      setShowDemoOTP(false);

      // 1. Save card details to vault
     await savePaymentMethod({
  ...cardFormData,
  type: detectCardType(cardFormData.number)?.name || null,  // ✅ card type add ho jayega
});


      // 2. Create token for payment
      const apiBase = process.env.REACT_APP_BASE_URL;
      const url = apiBase.endsWith("/")
        ? apiBase + "user/create_token"
        : apiBase + "/user/create_token";

      const payload = {
        payment_source: {
          card: {
            number: cardFormData.number,
            expiry: `${cardFormData.expire_year}-${cardFormData.expire_month}`, // ✅ correct keys
            security_code: cardFormData.cvv2, // ✅ cvv2 backend field
            name: `${cardFormData.first_name} ${cardFormData.last_name}`, // ✅ combine first + last name
            billing_address: {
              address: cardFormData.billing_address.address, // ✅ correct key (was "address")
              city: cardFormData.billing_address.city,
              state: cardFormData.billing_address.state,
              postal_code: cardFormData.billing_address.postal_code,
              country_code: cardFormData.billing_address.country_code,
            },
          },
        },
        user_id: cardFormData.user_id,
      };

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const responseData = await response.json();
      const token = responseData.data?.setup_token;
      if (!token) {
        throw new Error("No token ID received");
      }

      // 3. Book chef with token
      await bookChef(token);

      setShowPaymentDialog(false);
    } catch (error) {
      console.error("Payment processing error:", error);
      console.log(error.message || "Payment failed. Please try again.");
      setShowPaymentDialog(true);
    }
  };

  const savePaymentMethod = async (paymentData) => {
    setIsSaving(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}user/add_card_to_vault`,
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...paymentData,
            user_id: localStorage.getItem("logged_user_id"),
          }),
        }
      );

      const data = await response.json();

      if (!data.status) {
        throw new Error(data.message || "Failed to save payment method");
      }

      if (paymentData.type === "paypal") {
        localStorage.setItem("paypal_vault_id", paymentData.vault_id);
      } else if (paymentData.type === "card") {
        localStorage.setItem("card_vault_id", data.vault_id);
      }

      console.log("Payment method saved successfully!");
      onPaymentMethodSelect(paymentData.type);
      onClose();
      navigate("/subscription-summary");
    } catch (error) {
      console.error("Error saving payment method:", error);
      
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Dialog
    open={open}
    onClose={() => !isSaving && onClose()}
    maxWidth={false}
    fullWidth={false}
    aria-labelledby="payment-method-dialog-title"
    PaperProps={{
      sx: {
        width: isMobile ? "95vw" : "360px", // responsive width
        maxWidth: isMobile ? "95vw" : "360px",
        padding: 0,
        margin: 0,
        borderRadius: "10px",
        overflow: "hidden",
        maxHeight: "95vh",
      },
    }}
  >
    <Box
      sx={{
        p: 1, // padding thoda kam kiya
        overflowY: "auto",
        maxHeight: "90vh",
        "& *": { fontSize: "0.85rem" }, // sab ka font chhota
        "&::-webkit-scrollbar": {
          width: "4px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#c1c1c1",
          borderRadius: "3px",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Typography variant="h6">Save Payment Method</Typography>
        <IconButton onClick={onClose} disabled={isSaving}></IconButton>
      </Box>

      <Box sx={{ mb: 2 }}>
        {/* PayPal Option */}
        <Paper
          variant="outlined"
          onClick={() => !isSaving && setSelectedMethod("paypal")}
          sx={{
            p: 1.2, // less padding
            mb: 1.2,
            cursor: isSaving ? "not-allowed" : "pointer",
            border:
              selectedMethod === "paypal"
                ? "1.5px solid #0070ba"
                : "1px solid #e0e0e0", // thinner border
            bgcolor: selectedMethod === "paypal" ? "#f5f9fc" : "transparent",
            borderRadius: "7px", // slightly less rounded
            opacity: isSaving ? 0.7 : 1,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Radio
              checked={selectedMethod === "paypal"}
              disabled={isSaving}
            />
            <Box>
              <Typography>PayPal</Typography>
              <Typography variant="body2" color="text.secondary">
                Save PayPal for future payments
              </Typography>
            </Box>
            <Chip
              label="Recommended"
              color="primary"
              size="small"
              sx={{ ml: "auto" }}
            />
          </Box>
        </Paper>

        {selectedMethod === "paypal" && (
          <Box sx={{ mt: 2, mb: 3 }}>
            {paypalError && (
              <Typography color="error" sx={{ mb: 2, textAlign: "center" }}>
                {paypalError}
              </Typography>
            )}
            <PaypalVaultSection
              onPaymentSaved={handlePayPalSuccess}
              onError={handlePayPalError}
              address={address}
              postalCode={postalCode}
            />
          </Box>
        )}

        {/* Card Option */}
        <Paper
          variant="outlined"
          onClick={() => !isSaving && setSelectedMethod("card")}
          sx={{
            p: 1.2,
            cursor: isSaving ? "not-allowed" : "pointer",
            border:
              selectedMethod === "card"
                ? "1.5px solid #0070ba"
                : "1px solid #e0e0e0",
            bgcolor: selectedMethod === "card" ? "#f5f9fc" : "transparent",
            borderRadius: "7px",
            opacity: isSaving ? 0.7 : 1,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Radio checked={selectedMethod === "card"} disabled={isSaving} />
            <Box>
              <Typography>Credit/Debit Card</Typography>
              <Typography variant="body2" color="text.secondary">
                Save card for future payments
              </Typography>
            </Box>
          </Box>
        </Paper>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mt: 2, textAlign: "center" }}
        >
          Your payment information is securely stored by PayPal
        </Typography>

        {selectedMethod === "card" && (
          <Box sx={{ mt: 1 }}>
            <form onSubmit={handleCardSubmit} style={{ width: "100%" }}>
              <div className="mb-2">
                <input
                  placeholder="Card Number"
                  type="text"
                  name="cardNumber"
                  maxLength={19}
                  className="form-control shadow-none"
                  style={{
                    borderRadius: "12px",
                    backgroundColor: "rgba(128, 128, 128,0.2)",
                    //textAlign: "center",
                    fontSize: "0.92rem",
                    height: "32px",
                    padding: "2px 10px",
                  }}
                  onChange={(e) => {
                    const value = e.target.value;
                    e.target.value = formatCardNumber(value);
                    setCardType(detectCardType(e.target.value));
                  }}
                />
              </div>
              <div className="row">
                <div className="col-6 mb-2">
                  <input
                    placeholder="Month (MM)"
                    type="text"
                    name="expMonth"
                    maxLength={2}
                    className="form-control shadow-none"
                    style={{
                      borderRadius: "12px",
                      backgroundColor: "rgba(128, 128, 128,0.2)",
                      // textAlign: "center",
                      fontSize: "0.92rem",
                      height: "32px",
                      padding: "2px 10px",
                    }}
                  />
                </div>
                <div className="col-6 mb-2">
                  <input
                    placeholder="Year (YYYY)"
                    type="text"
                    name="expYear"
                    maxLength={4}
                    className="form-control shadow-none"
                    style={{
                      borderRadius: "12px",
                      backgroundColor: "rgba(128, 128, 128,0.2)",
                      // textAlign: "center",
                      fontSize: "0.92rem",
                      height: "32px",
                      padding: "2px 10px",
                    }}
                  />
                </div>
              </div>
              <div className="mb-2">
                <input
                  placeholder="CVV"
                  type="text"
                  name="cvv"
                  maxLength={3}
                  className="form-control shadow-none"
                  style={{
                    borderRadius: "12px",
                    backgroundColor: "rgba(128, 128, 128,0.2)",
                    // textAlign: "center",
                    fontSize: "0.92rem",
                    height: "32px",
                    padding: "2px 10px",
                  }}
                />
              </div>
              <div className="row">
                <div className="col-6 mb-2">
                  <input
                    placeholder="First Name"
                    type="text"
                    name="firstName"
                    className="form-control shadow-none"
                    style={{
                      borderRadius: "12px",
                      backgroundColor: "rgba(128, 128, 128,0.2)",
                      // textAlign: "center",
                      fontSize: "0.92rem",
                      height: "32px",
                      padding: "2px 10px",
                    }}
                  />
                </div>
                <div className="col-6 mb-2">
                  <input
                    placeholder="Last Name"
                    type="text"
                    name="lastName"
                    className="form-control shadow-none"
                    style={{
                      borderRadius: "12px",
                      backgroundColor: "rgba(128, 128, 128,0.2)",
                      // textAlign: "center",
                      fontSize: "0.92rem",
                      height: "32px",
                      padding: "2px 10px",
                    }}
                  />
                </div>
              </div>
              <div className="mb-2">
                <input
                  placeholder="Address"
                  type="text"
                  name="address"
                  className="form-control shadow-none"
                  style={{
                    borderRadius: "12px",
                    backgroundColor: "rgba(128, 128, 128,0.2)",
                    // textAlign: "center",
                    fontSize: "0.92rem",
                    height: "32px",
                    padding: "2px 10px",
                  }}
                />
              </div>
              <div className="row">
                <div className="col-6 mb-2">
                  <input
                    placeholder="City"
                    type="text"
                    name="city"
                    className="form-control shadow-none"
                    style={{
                      borderRadius: "12px",
                      backgroundColor: "rgba(128, 128, 128,0.2)",
                      // textAlign: "center",
                      fontSize: "0.92rem",
                      height: "32px",
                      padding: "2px 10px",
                    }}
                  />
                </div>
                <div className="col-6 mb-2">
                  <input
                    placeholder="State"
                    type="text"
                    name="state"
                    className="form-control shadow-none"
                    style={{
                      borderRadius: "12px",
                      backgroundColor: "rgba(128, 128, 128,0.2)",
                      //textAlign: "center",
                      fontSize: "0.92rem",
                      height: "32px",
                      padding: "2px 10px",
                    }}
                  />
                </div>
              </div>
              <div className="mb-2">
                <input
                  placeholder="Postal Code"
                  type="text"
                  name="postalCode"
                  className="form-control shadow-none"
                  style={{
                    borderRadius: "12px",
                    backgroundColor: "rgba(128, 128, 128,0.2)",
                    // textAlign: "center",
                    fontSize: "0.92rem",
                    height: "32px",
                    padding: "2px 10px",
                  }}
                />
              </div>
              <div className="mb-2">
                <input
                  placeholder="Country"
                  type="text"
                  name="countryCode"
                  value="United States"
                  readOnly
                  className="form-control shadow-none"
                  style={{
                    borderRadius: "12px",
                    backgroundColor: "rgba(128, 128, 128,0.08)",
                    textAlign: "center",
                    fontSize: "0.92rem",
                    color: "#000",
                    height: "32px",
                    padding: "2px 10px",
                  }}
                />
              </div>
              <div className="mb-3 d-flex justify-content-center">
                <ReCAPTCHA
                  sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                  onChange={(token) => setRecaptchaToken(token)}
                />
              </div>
              <div className="mb-3">
                <button
                  type="submit"
                  className="btn-orange w-100 text-center"
                  style={{
                    fontSize: "0.98rem",
                    height: "36px",
                    borderRadius: "18px",
                  }}
                  disabled={isSaving || !recaptchaToken}
                >
                  {isSaving ? "Saving..." : "Save Card"}
                </button>
              </div>
            </form>
          </Box>
        )}
      </Box>

      <Button
        fullWidth
        variant="text"
        onClick={onClose}
        disabled={isSaving}
        sx={{ mt: 1, color: "#FF5733", fontSize: "0.92rem" }}
      >
        Skip & Continue
      </Button>

      {showDemoOTP && (
        <DemoOTPDialog
          open={showDemoOTP}
          onClose={() => setShowDemoOTP(false)}
          onVerify={handleOTPVerify}
          cardFormData={cardFormData}
          navigate={navigate}
        />
      )}
    </Box>
  </Dialog>
  );
};

// Main Component
function BookingDetailSummary(props) {
  const [details, setDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showBreakup, setShowBreakup] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [chef_id, setChefId] = useState("");
  const [plan_id, setPlan_id] = useState("");
  const [address, setAddress] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [booking_date, setbookingDate] = useState("");
  const [timeslots, setTimeslots] = useState("");
  const [subscriptionTimeslot, setSubscriptionTimeslot] = useState("");
  const [food_categories_id, setFoodCategoryId] = useState("");
  const [food_categories_name, setFoodCategoryName] = useState("");
  const [allergies, setAllergies] = useState("");
  const [chef_grocery_pickup, setGroceryPick] = useState();
  const [groceryFees, setGroceryFees] = useState(0);
  const [totalFees, setTotalFees] = useState(0);
  const [menu_item, setMenuItem] = useState([]);
  const [instructions_for_chef, setInstructionsChef] = useState("");
  const [planStatus, setPlanStatus] = useState();
  const [planName, setPlanName] = useState("");
  const [base_charge, setbaseCharge] = useState("0");
  const [showPaymentDialog, setShowPaymentDialog] = useState(false);
  const [showCardModal, setShowCardModal] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  let navigate = useNavigate();
  const service_fees = 0;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const sanitizeTimeslot = (slot) => {
    if (!slot) return "";
    const trimmed = slot.trim();
    const normalized = trimmed.toLowerCase();
    if (normalized === "undefined" || normalized === "null") {
      return "";
    }
    return trimmed;
  };

  const updateGroceryPart = (value) => {
    setGroceryPick(value);
    localStorage.setItem("chef_grocery_pickup", value);
    setGroceryFees(value === "Yes" ? 14.99 : 0);
    setTotalFees(parseFloat(base_charge) + (value === "Yes" ? 14.99 : 0));
  };

  const updateChefs = async (chef_id) => {
    setLoading(true);
    try {
      let data = await fetch(
        `${process.env.REACT_APP_BASE_URL}user/get_chef_detail`,
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            chef_id: chef_id.toString(),
          }),
        }
      );
      let parsedData = await data.json();
      setDetails(parsedData.data);
      setLoading(false);
    } catch (error) {
      callErrorApi(
        `catch_error: ${process.env.REACT_APP_BASE_URL}user/get_chef_detail`,
        localStorage.getItem("owner"),
        error
      );
      setLoading(false);
    }
  };

  function navigateToDetail() {
    navigate(-1);
  }

  let getUserPlans = async () => {
    if (localStorage.getItem("logged_user_id")) {
      try {
        let response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/subscription/check_current_plan`,
          {
            method: "POST",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              user_id: `${localStorage.getItem("logged_user_id")}`,
              postal_code: `${localStorage.getItem("postalCode")}`,
            }),
          }
        );
        let responseData = await response.json();
        if (responseData.status) {
          console.log(responseData.plan_name);
          setPlanStatus(responseData.plan_status);
          setPlanName(responseData.plan_name || "");
        } else {
          console.log("Sorry unable to fetch");
        }
      } catch (error) {
        console.error("Error fetching subscription data:", error);
      }
    } else {
      try {
        let response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/subscription/fetch_plan_details`,
          {
            method: "POST",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              plan_id: `${localStorage.getItem("plan_id")}`,
            }),
          }
        );
        let responseData = await response.json();
        if (responseData.status) {
          console.log(responseData.plan_name);
          setPlanStatus(responseData.plan_status);
          setPlanName(responseData.plan_name || "");
        } else {
          console.log("Sorry unable to fetch");
        }
      } catch (error) {
        console.error("Error fetching subscription data:", error);
      }
    }
  };

  useEffect(() => {
    setChefId(localStorage.getItem("chef_id"));
    updateChefs(localStorage.getItem("chef_id"));
    setAddress(localStorage.getItem("address").replaceAll(",", ", "));
    setPostalCode(localStorage.getItem("postalCode"));
    setbookingDate(localStorage.getItem("booking_date"));
    const storedTimeslot = sanitizeTimeslot(localStorage.getItem("timeslots"));
    if (localStorage.getItem("timeslots") && !storedTimeslot) {
      localStorage.removeItem("timeslots");
    }
    setTimeslots(storedTimeslot);
    const foodCategories = localStorage.getItem("food_categories");
    if (foodCategories) {
      setFoodCategoryId(foodCategories.split("-")[0]);
      setFoodCategoryName(foodCategories.split("-")[1]);
    } else {
      setFoodCategoryId("");
      setFoodCategoryName("");
    }
    setAllergies(localStorage.getItem("allergies"));
    setInstructionsChef(localStorage.getItem("instructions_for_chef"));
    setMenuItem([
      {
        item_number: localStorage.getItem("item_number_1"),
        portion: localStorage.getItem("portion_1"),
      },
      {
        item_number: localStorage.getItem("item_number_2"),
        portion: localStorage.getItem("portion_2"),
      },
      {
        item_number: localStorage.getItem("item_number_3"),
        portion: localStorage.getItem("portion_3"),
      },
      {
        item_number: localStorage.getItem("item_number_4"),
        portion: localStorage.getItem("portion_4"),
      },
    ]);
    // setGroceryPick(localStorage.getItem("chef_grocery_pickup"));
    // setGroceryFees(
    //   localStorage.getItem("chef_grocery_pickup") === "Yes" ? 14.99 : 0
    // );
    setTotalFees(
      parseFloat(base_charge) +
        (localStorage.getItem("chef_grocery_pickup") === "Yes" ? 14.99 : 0)
    );
    fetchSubscriptionData();
    // eslint-disable-next-line
    getUserPlans();
  }, [base_charge]);

  let fetchSubscriptionData = async () => {
    try {
      let response = await fetch(
        `${process.env.REACT_APP_BASE_URL}subscription/check_current_plan`,
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_id: `${localStorage.getItem("logged_user_id")}`,
            postal_code: `${localStorage.getItem("postalCode")}`,
          }),
        }
      );
      let responseData = await response.json();

      console.log(responseData.price);
      setbaseCharge(responseData.price);

      console.log(responseData.plan_id);
      setPlan_id(responseData.plan_id);
      console.log(base_charge);
    } catch (error) {
      console.error("Error fetching subscription data:", error);
    }
  };

  // Helper to determine whether current plan should hide date/timeslot
  const isSubscriptionPlan = () => {
    const name = (planName || "").toLowerCase().trim();
    return name === "multiple times a week" || name === "weekly";
  };

  useEffect(() => {
    if (planStatus && !timeslots) {
      fetchSubscriptionTimeslotForChef();
    }
  }, [planStatus, timeslots]);

  const fetchSubscriptionTimeslotForChef = async () => {
    const userId = localStorage.getItem("logged_user_id");
    const chefIdFromStorage = localStorage.getItem("chef_id");

    if (!userId || !chefIdFromStorage) return;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}subscription/fetch_subscription_chef`,
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_id: userId,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const responseData = await response.json();

      if (Array.isArray(responseData)) {
        const planForChef = responseData.find(
          (plan) =>
            plan.chef &&
            plan.chef.some(
              (chef) =>
                chef.subscribe_chef_id &&
                chef.subscribe_chef_id.toString() ===
                  chefIdFromStorage.toString()
            )
        );

        const chefData =
          planForChef?.chef?.find(
            (chef) =>
              chef.subscribe_chef_id &&
              chef.subscribe_chef_id.toString() ===
                chefIdFromStorage.toString()
          ) || null;

        const rawTimeslot = chefData?.timeslot;

        if (rawTimeslot) {
          const normalizedSlot = rawTimeslot.replace(/^Every\s*/i, "").trim();
          setSubscriptionTimeslot(normalizedSlot);
          setTimeslots(normalizedSlot);
          localStorage.setItem("timeslots", normalizedSlot);
        }
      }
    } catch (error) {
      console.error("Error fetching subscription timeslot:", error);
    }
  };

  const bookChef = async (cardTokenOrEvent) => {
    let cardToken = null;
    let isEvent = cardTokenOrEvent && cardTokenOrEvent.preventDefault;

    if (isEvent) {
      cardTokenOrEvent.preventDefault();
    } else {
      cardToken = cardTokenOrEvent; // PayPal token
    }

    setIsSubmitting(true);

    try {
      var formdata = new FormData();
      formdata.append("chef_id", chef_id);
      formdata.append("address", address);
      formdata.append("postal_code", postalCode);
      formdata.append("booking_date", booking_date);
      formdata.append("timeslots", timeslots);
      formdata.append("food_categories", food_categories_id);
      formdata.append("allergies", $("#allergies").val());
      formdata.append(
        "instructions_for_chef",
        $("#instructions_for_chef").val()
      );
      formdata.append("chef_grocery_pickup", chef_grocery_pickup);
      formdata.append("menu_item", JSON.stringify(menu_item));
      formdata.append(
        "payment_details",
        JSON.stringify([
          { base_charge: base_charge.toString() },
          { grocery_fees: groceryFees.toString() },
          { service_fee: service_fees.toString() },
          { sub_total: totalFees.toString() },
          { total_booking_payment: totalFees.toString() },
        ])
      );
      formdata.append("total_payment", totalFees.toString());
      formdata.append("user_id", localStorage.getItem("logged_user_id"));
      formdata.append("email", localStorage.getItem("owner"));
      formdata.append("plan_id", plan_id);
      if (cardToken) {
        formdata.append("card_token", cardToken);
      } else {
        formdata.append("card_token", selectedCard?.id);
      }
      const subscriptionId = localStorage.getItem("subscription_id");
      if (subscriptionId) {
        formdata.append("subscription_id", subscriptionId);
      }
      let response = await fetch(
        `${process.env.REACT_APP_BASE_URL}book/book_chef`,
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          body: formdata,
          redirect: "follow",
        }
      );
      const res_json = await response.text();
      const data = JSON.parse(res_json);

      if (data.status === true) {
        localStorage.removeItem("redirect_to");
        localStorage.removeItem("allergies");
        localStorage.removeItem("item_number_1");
        localStorage.removeItem("item_number_2");
        localStorage.removeItem("item_number_3");
        localStorage.removeItem("item_number_4");
        localStorage.removeItem("portion_1");
        localStorage.removeItem("portion_2");
        localStorage.removeItem("portion_3");
        localStorage.removeItem("portion_4");
        localStorage.removeItem("instructions_for_chef");
        localStorage.removeItem("chef_grocery_pickup");
        // localStorage.removeItem("address");
        // localStorage.removeItem("postalCode");
        localStorage.removeItem("booking_date");
       // localStorage.removeItem("timeslots");
        localStorage.removeItem("food_categories");
        localStorage.removeItem("food_categories_id");
        localStorage.removeItem("food_categories_name");
        localStorage.removeItem("redirect_to");
        if (
          localStorage.getItem("is_guest_user") === "1" ||
          localStorage.getItem("is_guest_user") === "true"
        ) {
          navigate("/order-list");
        } else {
          navigate("/booking-detail/confirm");
        }
        // --- end guest user logic ---
        return true;
      } else {
        callErrorApi(
          `response_error: ${process.env.REACT_APP_BASE_URL}book/book_chef`,
          localStorage.getItem("owner"),
          data
        );
        setIsSubmitting(false);
        return false;
      }
    } catch (error) {
      callErrorApi(
        `catch_error: ${process.env.REACT_APP_BASE_URL}book/book_chef`,
        localStorage.getItem("owner"),
        error
      );
      setIsSubmitting(false);
      return false;
    }
    setIsSubmitting(false);
  };

  const handlePaymentMethodSelect = (method) => {
    console.log(`Selected payment method: ${method}`);
    if (method === "paypal") {
      const vaultId = localStorage.getItem("paypal_vault_id");
      if (vaultId) {
        console.log("PayPal vault ID found:", vaultId);
        // You can store this in your state if needed
        setShowPaymentDialog(false);
      }
    }
  };

  const handleCardSaved = () => {
    setShowCardModal(false);
  };

  const handleConfirmBooking = () => {
    setShowPaymentDialog(true);
  };

  // Move this outside of handleConfirmBooking!
  if (loading) return <Spinner />;

  return (
    <>
      <LoggedNav customer={props.customer} />
      {isMobile && (
        <div className="fixBoxOrange">
          <div className="edit_btn">
            {showBreakup && (
              <>
                <div className="d-flex justify-content-between align-items-center">
                  <p>Base Charge </p>
                  <p style={{ fontWeight: 700 }}>${base_charge.toFixed(2)}</p>
                </div>
                {/* {(chef_grocery_pickup === "Yes" || groceryFees) && (
                  <div className="d-flex justify-content-between align-items-center">
                    <p>Grocery Delivery Fee</p>
                    <p style={{ fontWeight: 700 }}>${groceryFees.toFixed(2)}</p>
                  </div>
                )} */}
              </>
            )}
            <div className="d-flex justify-content-between align-items-center">
              <p style={{ fontWeight: 700 }}>Total Payment After Meal</p>
              <p style={{ fontWeight: 700 }}>${totalFees.toFixed(2)}</p>
            </div>
            <div className="d-flex mt-1 justify-content-between align-items-center">
              <p
                id="showBreakup"
                className={showBreakup ? "d-none" : ""}
                style={{
                  fontSize: "0.8rem",
                  color: "#FF5E41",
                  cursor: "pointer",
                }}
                onClick={() => setShowBreakup(true)}
              >
                See Breakup
              </p>
              <p
                id="hideBreakup"
                className={!showBreakup ? "d-none" : ""}
                style={{
                  fontSize: "0.8rem",
                  color: "#FF5E41",
                  cursor: "pointer",
                }}
                onClick={() => setShowBreakup(false)}
              >
                Hide Breakup
              </p>
            </div>
            {/* <p style={{ fontSize: "0.7rem", color: "#7C7C7C" }}>
              Grocery bill charges will be added to reimburse the chef
            </p> */}
            
            {/* Mobile Confirm Booking Button inside orange box */}
            <div className="mt-3">
              <button
                type="button"
                className="btn btn-orange rounded-pill"
                style={{ 
                  width: "100%",
                  fontSize: "1rem",
                  fontWeight: "600",
                  padding: "12px 20px"
                }}
                onClick={handleConfirmBooking}
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <span className="spinner-border spinner-border-sm me-2"></span>
                ) : null}
                Confirm Booking
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="container my-5 border border-0">
        {!isMobile && (
          <nav aria-label="breadcrumb">
            <a
              onClick={navigateToDetail}
              style={{
                textDecoration: "none",
                color: "black",
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              <RiArrowLeftSLine size={"2.3rem"} />{" "}
              <span
                style={{
                  textDecoration: "none",
                  color: "orange",
                  fontWeight: 700,
                }}
              >
                {details[0]?.chef_name}{" "}
              </span>
            </a>
            / Enter Booking Details
          </nav>
        )}
        <div className="main_container row">
          {!isMobile && (
            <div className="col-5">
              <div className="box_title">
                <h1>{details[0]?.chef_name}</h1>
                <h5 style={{ marginTop: "15px" }}>{details[0]?.chef_city}</h5>
              </div>
              <div className="d-flex justify-content-start pt-3 mt-3">
                <Rating
                  name="half-rating-read"
                  defaultValue={Number(details[0]?.chef_rating)}
                  precision={0.5}
                  readOnly
                />
                <div className="d-flex justify-content-center ms-3">
                  <p style={{ fontSize: "0.9rem", color: "#7C7C7C" }}>
                    {details[0]?.chef_total_number_of_reviews} reviews
                  </p>
                </div>
              </div>
              <div
                className="image_box"
                style={{
                  backgroundImage: `url(${details[0]?.chef_profile_image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  width: "80px",
                  height: "80px",
                  borderRadius: "20px",
                  marginTop: "20px",
                }}
              />
            </div>
          )}
          <div
            className={
              isMobile
                ? "col-12 p-4 d-flex flex-column justify-content-center align-items-center"
                : "col-7 p-5 d-flex flex-column justify-content-center align-items-center"
            }
            style={{
              boxShadow: isMobile ? "" : "0px 0px 8px rgba(0, 0, 0, 0.1)",
              border: "none",
              borderRadius: isMobile ? "" : "20px",
            }}
          >
            <form id="profile-chef-complete">
              <div
                className="box_title"
                style={{
                  width: isMobile ? "100%" : "50%",
                  height: "auto",
                  margin: "auto",
                }}
              >
                <h4
                  className={isMobile ? "" : "mt-5"}
                  style={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "1.5rem",
                  }}
                >
                  Booking Summary
                </h4>
                <p style={{ textAlign: "center" }}>
                  Check all details before confirming
                </p>
              </div>

              <div
                className="box_title py-2 my-2"
                style={{
                  background: "#FFFFFF",
                  boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
                  borderRadius: "15px",
                  width: isMobile ? "95%" : "90%",
                  margin: "auto",
                }}
              >
                <div className="d-flex justify-content-between mx-3">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label fw-bold"
                  >
                    Address for service
                  </label>
                  {!planStatus && (
                    <BiPencil
                      size={18}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        navigate("/booking-detail", {
                          state: {
                            chef_id: chef_id,
                            address: address,
                            postal_code: postalCode,
                          },
                        });
                      }}
                    />
                  )}
                </div>
                <div className="mx-3">
                  <p className="m-0">{address}</p>
                </div>
                <div className="d-flex justify-content-between mx-3 mt-3">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label fw-bold small"
                  >
                    {`Specific Zip Code: ${postalCode}`}
                  </label>
                </div>
              </div>

              {!isSubscriptionPlan() && (
                <div
                  className="box_title py-2 my-2"
                  style={{
                    background: "#FFFFFF",
                    boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
                    borderRadius: "15px",
                    width: isMobile ? "95%" : "90%",
                    margin: "auto",
                  }}
                >
                  <div className="d-flex justify-content-between mx-3">
                    <label className="form-label fw-bold">Date Selected</label>
                    {!planStatus && (
                      <BiPencil
                        size={18}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          navigate("/booking-detail", {
                            state: {
                              chef_id: chef_id,
                              address: address,
                              postal_code: postalCode,
                            },
                          });
                        }}
                      />
                    )}
                  </div>
                  <div className="mx-3">
                    <p className="m-0">{booking_date}</p>
                  </div>
                </div>
              )}

              {!isSubscriptionPlan() && (
                <div
                  className="box_title py-2 my-2"
                  style={{
                    background: "#FFFFFF",
                    boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
                    borderRadius: "15px",
                    width: isMobile ? "95%" : "90%",
                    margin: "auto",
                  }}
                >
                  <div className="d-flex justify-content-between mx-3">
                    <label className="form-label fw-bold">
                      Timeslot Selected
                    </label>
                    {!planStatus && (
                      <BiPencil
                        size={18}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          navigate("/booking-detail", {
                            state: {
                              chef_id: chef_id,
                              address: address,
                              postal_code: postalCode,
                            },
                          });
                        }}
                      />
                    )}
                  </div>
                  <div className="mx-3">
                    <p className="m-0">{timeslots}</p>
                  </div>
                </div>
              )}

              <div
                className="box_title py-2 my-2"
                style={{
                  background: "#FFFFFF",
                  boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
                  borderRadius: "15px",
                  width: isMobile ? "95%" : "90%",
                  margin: "auto",
                }}
              >
                <div className="d-flex justify-content-between mx-3">
                  <label className="form-label fw-bold">
                    Cuisine/Diet Selected
                  </label>
                  {!planStatus && (
                    <BiPencil
                      size={18}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        navigate("/booking-detail", {
                          state: {
                            chef_id: chef_id,
                            address: address,
                            postal_code: postalCode,
                          },
                        });
                      }}
                    />
                  )}
                </div>
                <div className="mx-3">
                  <p className="m-0">{food_categories_name}</p>
                </div>
              </div>

              <div
                className="form_box"
                style={{ width: isMobile ? "95%" : "90%", margin: "auto" }}
              >
                <div className="row my-4">
                  <div className="col-7">
                    <h6 className="fw-bold text-nowrap">
                      Enter menu item number
                    </h6>
                  </div>
                  <div className="col-1"></div>
                  <div className="col-4 text-center">
                    <h6 className="fw-bold text-nowrap">Portion Size</h6>
                  </div>
                  {menu_item.map((element, index) => {
                    return (
                      <div className="row my-1" key={index}>
                        <div className="col-7">
                          <input
                            disabled="disabled"
                            type="number"
                            className="form-control shadow-none"
                            placeholder={element.item_number}
                            defaultValue={element.item_number}
                          />
                        </div>
                        <div className="col-1"></div>
                        <div
                          className={
                            isMobile
                              ? "col-4 d-flex justify-content-end"
                              : "col-4 d-flex justify-content-center"
                          }
                        >
                          <select
                            defaultValue={element.portion}
                            disabled={"disabled"}
                          >
                            <option value="0">0</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                          </select>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="mb-3 mt-1 pt-1">
                  <label htmlFor="Input" className="form-label fw-bold">
                    Please state your allergies, if any
                  </label>
                  <input
                    type="text"
                    className="form-control shadow-none"
                    id="allergies"
                    style={{
                      borderRadius: "15px",
                      backgroundColor: "rgba(128, 128, 128,0.4)",
                    }}
                    placeholder="Enter Allergies"
                    defaultValue={allergies}
                  />
                </div>

                {/* <div className="mb-3 pt-3">
                  <label htmlFor="Input" className="form-label fw-bold">
                    Do you want the chef to pick up groceries?{" "}
                  </label>
                  <label>Grocery delivery fees is $14.99 </label>
                  <div className="mt-3 row ">
                    <div key="1" className="col p-0 mx-1">
                      <input
                        type="radio"
                        id="want-grocerties-yes"
                        name="chef_grocery_pickup"
                        onChange={() => updateGroceryPart("Yes")}
                        className="Send_data input-hidden"
                        value="Yes"
                        defaultChecked={chef_grocery_pickup === "Yes"}
                      />
                      <label
                        className="time-availablibilty"
                        htmlFor="want-grocerties-yes"
                        style={{ fontSize: "14px" }}
                      >
                        Yes
                      </label>
                    </div>
                    <div key="2" className="col p-0 mx-1">
                      <input
                        type="radio"
                        id="want-grocerties-no"
                        name="chef_grocery_pickup"
                        onChange={() => updateGroceryPart("No")}
                        className="Send_data input-hidden"
                        value="No"
                        defaultChecked={chef_grocery_pickup === "No"}
                      />
                      <label
                        className="time-availablibilty"
                        htmlFor="want-grocerties-no"
                        style={{ fontSize: "14px" }}
                      >
                        No
                      </label>
                    </div>
                  </div>
                </div> */}

                <div className="mb-3">
                  <label htmlFor="Input" className="form-label fw-bold">
                    Add instructions for the Chef{" "}
                  </label>
                  <input
                    type="text"
                    className="form-control shadow-none"
                    id="instructions_for_chef"
                    style={{
                      borderRadius: "15px",
                      backgroundColor: "rgba(128, 128, 128,0.4)",
                    }}
                    placeholder="Enter Instructions"
                    defaultValue={instructions_for_chef}
                  />
                </div>

                <div
                  className="box_title py-2"
                  style={{
                    background: "#FFFFFF",
                    boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
                    borderRadius: "15px",
                  }}
                >
                  <h6 className="ms-3 my-2">Disclaimer 👇</h6>
                  <ul>
                    <li className="p-1" style={{ fontSize: "0.8rem" }}>
                      Please keep all pots/pans ready and dishwasher empty.
                    </li>
                    <li className="p-1" style={{ fontSize: "0.8rem" }}>
                      We would appreciate if any pets at home are restrained for
                      Chef's safety
                    </li>
                  </ul>
                </div>

                <div className="accordion my-3" id="accordionExample">
                  <div className="accordion-item  border-0 shadow-none">
                    <h2
                      className="accordion-header border-0 shadow-none"
                      id="headingOne"
                      style={{
                        background: "#FFFFFF",
                        boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
                        borderRadius: "15px",
                      }}
                    >
                      <button
                        className="accordion-button bg-transparent border-0 shadow-none text-black"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        Cancelation Policy ❌
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div
                        className="accordion-body box_title"
                        style={{
                          background: "#FFFFFF",
                          boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
                          borderRadius: "15px",
                        }}
                      >
                        <p className="ms-3 my-2" style={{ fontSize: "0.8rem" }}>
                          <span className="fw-bold"> Scenario A: </span> If user
                          cancels the service, 24 hours and more before the
                          scheduled time of service, and the groceries are not
                          picked by the private chef, user will not be charged a
                          cancellation fee.
                        </p>
                        <p className="ms-3 my-2" style={{ fontSize: "0.8rem" }}>
                          <span className="fw-bold"> Scenario B: </span>If user
                          cancels the service, 24 hours and more before the
                          scheduled time of service, and the private chef has
                          picked the grocery, user will not be charged
                          cancellation fee. Instead user will be charged Grocery
                          Pick Up and Delivery Fee of $14.99 and the user will
                          incur Grocery Bill Reimbursement charge.
                        </p>
                        <p className="ms-3 my-2" style={{ fontSize: "0.8rem" }}>
                          <span className="fw-bold"> Scenario C: </span> If user
                          cancels the service, with less than 24 hours for the
                          scheduled time of service, and the groceries are not
                          picked by the private chef yet, there will be no
                          cancellation fee charge.
                        </p>
                        <p className="ms-3 my-2" style={{ fontSize: "0.8rem" }}>
                          <span className="fw-bold"> Scenario D: </span> If user
                          cancels the service, with less than 24 hours of the
                          scheduled time of service, and the groceries have been
                          picked by the private chef, user will not be charged a
                          cancellation fee, instead a grocery pickup and
                          delivery fee of $14.99 will be charged and user will
                          also incur a grocery bill reimbursement charge.
                        </p>
                        <p className="ms-3 my-2" style={{ fontSize: "0.8rem" }}>
                          <span className="fw-bold"> Scenario E: </span>If the
                          private chef at any time decides to cancel the service
                          scheduled, user will not be charged a cancellation fee
                          and neither is the Chef liable to pay a cancellation
                          fee.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {isMobile ? null : (
                  <>
                    <div className="bill_title text-center">
                      <h6 className="fw-bold">Total Bill</h6>
                    </div>
                    <div className="text-center">
                      <p style={{ fontSize: "0.8rem" }}>
                        Pricing is as per the Service Address Zip Code{" "}
                      </p>
                    </div>

                    <div
                      className="box_title py-2 my-4 d-flex justify-content-center py-5"
                      style={{
                        background: "#FFFFFF",
                        boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
                        borderRadius: "15px",
                      }}
                    >
                      <table width="80%">
                        <tbody>
                          <tr className="">
                            <td align="left" style={{ fontSize: "0.9rem" }}>
                              Base Charge
                            </td>
                            <td align="right" style={{ fontSize: "0.9rem" }}>
                              ${Number(base_charge).toFixed(2)}
                            </td>
                          </tr>
                          {/* {chef_grocery_pickup === "Yes" ? (
                            <tr className="">
                              <td align="left" style={{ fontSize: "0.9rem" }}>
                                Grocery Delivery Fee
                              </td>
                              <td align="right" style={{ fontSize: "0.9rem" }}>
                                ${groceryFees.toFixed(2)}
                              </td>
                            </tr>
                          ) : (
                            <tr></tr>
                          )} */}
                          <tr>
                            <td
                              align="left"
                              style={{ fontSize: "0.9rem" }}
                              className="fw-bold pt-4"
                            >
                              Total Payment After Meal Prep
                            </td>
                            <td
                              align="right"
                              style={{ fontSize: "0.9rem" }}
                              className="fw-bold pt-4"
                            >
                              ${totalFees.toFixed(2)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
              </div>
            </form>

            {/* Desktop Confirm Booking Button */}
            {!isMobile && (
              <div className="edit_btn mt-5 text-center">
                <button
                  type="button"
                  className="btn btn-orange rounded-pill mb-3"
                  style={{ width: "100%" }}
                  onClick={handleConfirmBooking}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <span className="spinner-border spinner-border-sm me-2"></span>
                  ) : null}
                  Confirm Booking
                </button>

                {/* <p style={{ fontSize: "0.7rem", color: "#7C7C7C" }}>
                  Grocery bill charges will be added to reimburse the chef
                </p> */}
              </div>
            )}


            {/* Payment Dialog - Shared for both mobile and desktop */}
            <PaymentMethodDialog
              open={showPaymentDialog}
              onClose={() => setShowPaymentDialog(false)}
              onPaymentMethodSelect={handlePaymentMethodSelect}
              address={address}
              postalCode={postalCode}
              setShowPaymentDialog={setShowPaymentDialog}
              bookChef={bookChef}
            />

            <CardFieldsModal
              show={showCardModal}
              onClose={() => setShowCardModal(false)}
              onCardSaved={handleCardSaved}
            />

          </div>
        </div>
      </div>
      <Footer top={1} />
    </>
  );
}

export default BookingDetailSummary;
